module.exports = __webpack_public_path__ + "static/ionv-33b066424e5f8c7f1f182a45151e85ae.png";